import React from 'react'
import mixpanel from 'mixpanel-browser'
import Header from './components/Header'
import About from './components/About'
import Experience from './components/Experience'
import Skills from './components/Skills'
import Education from './components/Education'

function Resume() {

    mixpanel.init('967772639ff06d979a760099b3066fe5', {debug: false, track_pageview: false, persistence: 'localStorage'})
    mixpanel.track('page-view')

    const handlePrint = () => {
        window.print()
    }

    return (
        <div className="min-h-screen bg-neutral-50">
            {/* Print Button */}
            <button
                onClick={handlePrint}
                className="no-print fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center justify-center gap-2 w-[calc(100%-3rem)] md:w-auto px-5 md:px-12 py-2.5 bg-primary text-white font-body font-medium text-sm rounded-full hover:bg-primary-light transition-all shadow-xl hover:shadow-2xl hover:-translate-y-0.5"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                Print Resume
            </button>

            {/* Main Content */}
            <div className="max-w-4xl mx-auto px-6 py-12 pb-24 md:px-12 md:py-16 md:pb-24">
                <Header />

                <div className="mt-8 space-y-12">
                    <About />
                    <Skills />
                    <Experience />
                    <Education />
                </div>

            </div>
        </div>
    )
}

export default Resume
